import StorageService from "../services/StorageService";
import { USER, SESSION } from "../constants/storageConstants";

/**
 * Forgets the signed-in admin in this browser: what Logout does once the server has ended the session
 * (store/auth/login/saga.js), and what the Clinicians page does after a super admin changes their own
 * login email - the server has already signed them out everywhere, so there is no session to end.
 */
export default function clearStoredSession() {
    const storage = new StorageService();
    storage.deleteValueByKey(SESSION);
    storage.deleteValueByKey(USER);
}
